import styled from 'styled-components'
import { Button as DefaultButton } from '~/shared/ui/Buttons'
import { TextEllipsis } from '~/shared/ui/Text'
import { myPalette } from '~/shared/ui/theme'

export const ContentBlur = styled.div`
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  --webkit-backdrop-filter: blur(4px);
  padding: 6px;
  border-radius: 8px;
`

export const PrevBlock = styled.div`
  position: absolute;
  width: 50%;
  height: 100%;
  left: 0;
  z-index: 2;
`

export const NextBlock = styled.div`
  position: absolute;
  width: 50%;
  height: 100%;
  right: 0;
  z-index: 2;
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: ${myPalette.black.main};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const PostContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 16px 0;
`

export const TitleWrapper = styled(TextEllipsis)`
  font-size: 22px;
  font-weight: 700;
  color: ${myPalette.white.main};
`

export const DescriptionWrapper = styled(TextEllipsis)`
  font-size: 16px;
  font-weight: 500;
  color: ${myPalette.white.main};
`

export const Button = styled(DefaultButton)`
  margin-bottom: 24px;
  position: relative;
  z-index: 3;
`

export const ShowMore = styled(ContentBlur)`
  font-size: 16px;
  font-weight: 500;
  color: ${myPalette.white.main};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 3;
  cursor: pointer;
  margin-bottom: 24px;
`
